export default "__VITE_ASSET__BBbLWK66__"